import OMCalendarComponent from "@/app/components/ui/Calendar/OMCalendar";
import SearchableMultiSelectMenu from "@/app/components/ui/SelectMenus/MultiSelectMenu";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import { useOrderTransferStatusListAPI } from "@/app/hooks/api_hooks/Inventory/ClinicToClinicTransfer/useOrderTransferStatusListAPI";
import { useClinicTamsFilterAPI } from "@/app/hooks/api_hooks/Inventory/useClinicTamsFilterAPI";
import { useOrderManagementClinicListAPI } from "@/app/hooks/api_hooks/orders/useOrderClinicListAPI";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import { IInventoryState } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { useEffect, useState } from "react";
import { FieldError, useForm } from "react-hook-form";
import { PRIMARY_BUTTON } from "@/constants";

export interface IClinicToClinicTransferProps {
  startDate: string;
  endDate: string;
  receiverClinics: Array<string>;
  senderClinics: Array<string>;
  statuses: Array<string>;
  inventoryType: Array<string>;
  clinic_tams: string;
}

const inventoryTypesList = [
  {
    id: 1,
    type: "Good",
  },
  {
    id: 2,
    type: "Bad",
  },
];

const types = [
  {
    id: "1",
    title: "TAMS",
  },
  {
    id: "2",
    title: "CLINIC",
  },
];

const OrderTransferFilters = ({ setOrderFilters }) => {
  const { execute: fetchClinicList, clinicList } = useClinicTamsFilterAPI();
  const clinicsOrgItem = useSelectMenuReducer(clinicList, "display_name", "id");
  const fetchOrgClinics = useOrderManagementClinicListAPI();
  const { transferStatusList } = useRouteInfo("INVENTORY")?.routeState?.state as IInventoryState;
  const transferStatusOptions = useSelectMenuReducer(transferStatusList, "status", "id");
  const inventoryOptions = useSelectMenuReducer(inventoryTypesList, "type", "id");
  const fetchStatusList = useOrderTransferStatusListAPI();
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 30);
  const [selectionDate, setSelectionDate] = useState({
    startDate: yesterday,
    endDate: today,
    key: "selectionDate",
  });
  const startDate = new Date(selectionDate.startDate);
  const endDate = new Date(selectionDate.endDate);
  const startEpoch = startDate.getTime();
  const endEpoch = endDate.getTime();
  const startYear = startDate.getFullYear();
  const startMonth = (startDate.getMonth() + 1).toString().padStart(2, "0");
  const startDay = startDate.getDate().toString().padStart(2, "0");
  const endYear = endDate.getFullYear();
  const endMonth = (endDate.getMonth() + 1).toString().padStart(2, "0");
  const endDay = endDate.getDate().toString().padStart(2, "0");
  const formattedStartDate = `${startYear}-${startMonth}-${startDay}`;
  const formattedEndDate = `${endYear}-${endMonth}-${endDay}`;
  const formHook = useForm<IClinicToClinicTransferProps>({
    mode: "onChange",
    defaultValues: {},
  });

  useEffect(() => {
    const selectedType = formHook.watch("clinic_tams");
    if (selectedType) {
      if (selectedType === "TAMS") {
        fetchClinicList("", "TAMS");
      } else if (selectedType === "CLINIC") {
        fetchClinicList("", "CLINIC");
      }
    }
  }, [formHook.watch("clinic_tams")]);

  useEffect(() => {
    fetchOrgClinics();
    fetchStatusList();
  }, []);

  const Submit = () => {
    const filters = {
      sender_clinic_ids: formHook.getValues("senderClinics"),
      receiver_clinic_ids: formHook.getValues("receiverClinics"),
      start_timestamp: Math.floor(startEpoch / 1000),
      end_timestamp: Math.floor(endEpoch / 1000),
      statuses: formHook.getValues("statuses"),
      inventory_type: formHook.getValues("inventoryType"),
    };
    setOrderFilters(filters);
  };
  return (
    <div>
      <form className="w-full" onSubmit={formHook.handleSubmit(Submit)}>
        <div className="w-full flex flex-wrap items-center gap-3 mt-2">
          <div className="flex-none w-full sm:w-[240px]">
            <OMCalendarComponent
              selectionDate={selectionDate}
              setSelectionDate={setSelectionDate}
              startDate={formattedStartDate}
              endDate={formattedEndDate}
              handelClick={() => {
                console.log();
              }}
            />
          </div>
          <div className="w-full sm:w-auto sm:flex-1 sm:min-w-[140px] sm:max-w-[220px]">
            <SearchableSelectMenu
              errorMessages={[{ type: "required", message: "Clinic/Tams is required" }]}
              onSelectItem={(item) => {
                if (item) {
                  formHook.setValue("clinic_tams", item?.title);
                }
              }}
              fieldError={(formHook?.formState?.errors?.clinic_tams as FieldError) ?? null}
              register={formHook.register("clinic_tams", { required: true })}
              selectItems={types}
              placeholder="Select Type"
              showTooltips={true}
              showTypedErrors={false}
              showDropdownIcon={true}
              defaultSelected={types?.filter((oc) => oc.title === formHook.watch("clinic_tams"))[0]}
              listBoxClassName="w-full"
              className="text-gray-800"
              containerClassName="w-full"
            />
          </div>
          <div className="w-full sm:w-auto sm:flex-1 sm:min-w-[180px] sm:max-w-[260px]">
            <SearchableMultiSelectMenu
              withSelectAll
              errorMessages={[]}
              onSelectItem={(item) => {
                if (item) {
                  const clincId = item?.map((i) => i?.id);
                  formHook.setValue("receiverClinics", clincId);
                }
              }}
              fieldError={formHook?.formState?.errors?.receiverClinics}
              register={formHook.register("receiverClinics")}
              selectItems={clinicsOrgItem}
              placeholder="Select Receiver Clinic"
              showTooltips={false}
              showTypedErrors={false}
              showDropdownIcon={true}
              defaultSelected={clinicsOrgItem?.filter((c) => formHook.watch("receiverClinics")?.includes(c?.id))}
              disabled={!formHook.watch("clinic_tams") || formHook.watch("clinic_tams")?.length === 0}
              className="text-gray-800"
              containerClassName="w-full"
            />
          </div>
          <div className="w-full sm:w-auto sm:flex-1 sm:min-w-[180px] sm:max-w-[260px]">
            <SearchableMultiSelectMenu
              withSelectAll
              errorMessages={[]}
              onSelectItem={(item) => {
                if (item) {
                  const clincId = item.map((i) => i?.id);
                  formHook.setValue("senderClinics", clincId);
                }
              }}
              fieldError={formHook?.formState?.errors?.senderClinics}
              register={formHook.register("senderClinics")}
              selectItems={clinicsOrgItem?.filter((clinic) => !formHook.watch("receiverClinics")?.includes(clinic?.id))}
              placeholder="Select Sender Clinic"
              showTooltips={false}
              showTypedErrors={false}
              showDropdownIcon={true}
              defaultSelected={clinicsOrgItem?.filter((c) => formHook.watch("senderClinics")?.includes(c?.id))}
              className="text-gray-800"
              containerClassName="w-full"
              disabled={!formHook.watch("clinic_tams") || formHook.watch("clinic_tams")?.length === 0}
            />
          </div>
          <div className="w-full sm:w-auto sm:flex-1 sm:min-w-[150px] sm:max-w-[220px]">
            <SearchableMultiSelectMenu
              withSelectAll
              errorMessages={[]}
              onSelectItem={(item) => {
                if (item) {
                  const statusId = item?.map((i) => i?.title);
                  formHook.setValue("statuses", statusId);
                }
              }}
              fieldError={formHook?.formState?.errors?.statuses}
              register={formHook.register("statuses")}
              selectItems={transferStatusOptions}
              placeholder="Select Status"
              showTooltips={false}
              showTypedErrors={false}
              showDropdownIcon={true}
              defaultSelected={transferStatusOptions?.filter((c) => formHook.watch("statuses")?.includes(c?.title))}
              className="text-gray-800"
              containerClassName="w-full"
            />
          </div>
          <div className="w-full sm:w-auto sm:flex-1 sm:min-w-[180px] sm:max-w-[220px]">
            <SearchableMultiSelectMenu
              withSelectAll
              errorMessages={[]}
              onSelectItem={(item) => {
                if (item) {
                  const type = item?.map((i) => i?.title);
                  formHook.setValue("inventoryType", type);
                }
              }}
              fieldError={formHook?.formState?.errors?.inventoryType}
              register={formHook.register("inventoryType")}
              selectItems={inventoryOptions}
              placeholder="Select Inventory Type"
              showTooltips={false}
              showTypedErrors={false}
              showDropdownIcon={true}
              defaultSelected={inventoryOptions?.filter((c) => formHook.watch("inventoryType")?.includes(c?.title))}
              className="text-gray-800"
              containerClassName="w-full"
            />
          </div>
          <div className="w-full sm:w-auto">
            <input type="submit" className={`${PRIMARY_BUTTON} w-full sm:w-auto`} value={"Search"} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default OrderTransferFilters;
